<template>
  <div v-if="partner" class="w-100">
    <div class="bg-offwhite h-100 py-4 px-3 rounded-corners-10 shadow-sm">
      <a v-if="partner.slug" :href="`/partners/${partner.slug}`" class="h-100">
          <img class="mb-3 rounded partner-logo-shadow single-partner-image" :src="partner?.logo?.xxx || defaultPartnerLogo" :alt="partner?.name"/>
          <h3 v-if="partner.name && partner.name.length && partner.name.length > 30" class="font-weight-bold m-0 pt-0 pt-md-3 text-dark font-size-mobile text-break h5">{{partner.name.slice(0, 30)}}...</h3>
          <h3 v-if="partner.name && partner.name.length && partner.name.length <= 30" class="font-weight-bold m-0 pt-0 pt-md-3 text-dark font-size-mobile text-break h5">
              {{partner.name}}</h3>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: "singlePartnerFeature",
  props: {
    settingsPerm: Object,
    partner: Object,
  },
  data() {
    return {
      defaultPartnerLogo: '/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/apartment1.svg',
    };
  },
  setup() {},
  

  created() {
    
  },

  methods: {
  },

};
</script>

<style scoped>
.single-partner-image{
    max-height: 150px;
    height: 150px;
    width: auto;
}

  /* Small devices (landscape phones, 544px and up) */
  @media (max-width: 767px) {
    .single-partner-image{
        max-height: 100px;
        object-fit: cover;
    }
    .font-size-mobile {
        font-size: 16px;
    }
  }
</style>
